import { render, staticRenderFns } from "./add-account.vue?vue&type=template&id=32063be4"
import script from "./add-account.vue?vue&type=script&lang=ts"
export * from "./add-account.vue?vue&type=script&lang=ts"
import style0 from "./add-account.vue?vue&type=style&index=0&id=32063be4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports